import { INVITATIONS_LIST_ACTION } from "../Actions/InvitationsListAction";


const initialstate = { invitations: [] };

const invitationsListReducer = (state = initialstate, action) => {
    switch (action.type) {
        case INVITATIONS_LIST_ACTION:
            return {
                ...state,
                invitations: action.payload,
            };
        default:
            return state
    }
}


export default invitationsListReducer;


